import { HighlightMatch } from '@/shared/components/ui'
import type { IdField } from '../hooks/use-chart-id-search'
import { idHitLength, isShown, type IdHit } from '../utils/id-hit'

/**
 * A displayed identifier with its match marked: the bulk condition's matched start
 * when `hit` targets this column, else the quick-search query (substring). A
 * masked or missing value is never marked.
 */
export function MatchedId({ text, field, query = '', hit }: { text: string; field: IdField; query?: string; hit?: IdHit }) {
  if (!isShown(text)) return <>{text}</>
  if (!hit) return <HighlightMatch text={text} query={query} />
  const n = hit.field === field ? idHitLength(text, hit) : 0
  return n ? <><mark className="search-hit">{text.slice(0, n)}</mark>{text.slice(n)}</> : <>{text}</>
}
